<script>
import GoogleMap from '@/components/googleMap'
import {DateUtil} from '@/utils/date.js'
export default {
  data () {
    return {
      viewModel: {},
      mapId: 'stationPlace',
      mapId2: 'stayPlace',
      centerPoint: {
        lat: null,
        lng: null
      },
      zoom: 15,
      markPosition: {},
      shiftReservation: {},
      time: {},
      title: ''
    }
  },
  props: {
  },
  watch: {
    'centerPoint' (newVal) {
      this.centerPoint = newVal
    }
  },
  methods: {
    initiGoogleMap (labelClass) {
      let imgSize = {width: 45, height: 60}
      let labelAnchor = {width: 22, height: 50}
      this.$refs.gMap.initializeGoogleMap().then(
        () => {
          this.$refs.gMap.map.setCenter(this.centerPoint)
          this.$refs.gMap.map.setZoom(this.zoom)
          this.$refs.gMap.addSingleMaker(this.markPosition, imgSize, labelClass, labelAnchor)
        }
      )
      this.$refs.tMap.initializeGoogleMap().then(
        () => {
          this.$refs.tMap.map.setCenter(this.centerPoint)
          this.$refs.tMap.map.setZoom(this.zoom)
          this.$refs.tMap.addSingleMaker(this.markPosition, imgSize, labelClass, labelAnchor)
        }
      )
    },
    commitServer () {
      this.$axios.get('shift/selectInfoName').then(response => {
        sessionStorage.setItem('userInfo', JSON.stringify(response.data.userInfo))
        this.$axios.get('shift/selectShiftReservation', {params: {reserveId: this.viewModel.reserveId}})
          .then(response => {
            this.shiftReservation = response.data.shiftReservation
            this.time.reserveTime = DateUtil.yearHourMinute(this.shiftReservation.reserveTime)
            this.time.useTime = DateUtil.yearWeek(this.shiftReservation.useTime)
            this.time.startEstimateTime = DateUtil.hourMinute(this.shiftReservation.startEstimateTime)
            this.time.arriveEstimateTime = DateUtil.hourMinute(this.shiftReservation.arriveEstimateTime)
            this.shiftReservation.time = this.time
            this.shiftReservation.flag = 'edit'
            sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
            this.$router.push({
              path: '/passengerReservationDetail',
              name: 'passengerReservationDetail',
              query: {title: this.title}
            })
          })
          .catch(error => {
            console.log(error)
          })
      })
    }
  },
  components: { GoogleMap }
}
</script>

<template>
    <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-station-dialog" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png"/></button>
                        <h3 class="modal-title" id="myModalLabel" v-text="viewModel.routeType==0?'停留所詳細':'経由地詳細'"></h3>
                    </div>
                    <div class="modal-body">
                        <div class="row clearfix">
                            <div class="col-md-7 column">
                                <table class="table table-bordered window-table">
                                    <tbody>
                                        <tr v-show="viewModel.routeType==0">
                                            <td class="td-key F3-R-15 bgc8">停留所名</td>
                                            <td class="td-value F3-M-18">{{viewModel.name}}</td>
                                        </tr>
                                        <tr v-show="viewModel.routeType==1">
                                            <td class="td-key F3-R-15 bgc8">乗客</td>
                                            <td class="td-value F3-M-18">{{viewModel.name}}</td>
                                        </tr>
                                            <tr v-show="viewModel.routeType==0">
                                            <td class="td-key F3-R-15 bgc8">停留所ID</td>
                                            <td class="td-value F3-M-18">{{viewModel.displayStationId}}</td>
                                        </tr>
                                        <tr v-show="viewModel.routeType==1">
                                            <td class="td-key F3-R-15 bgc8" v-if="viewModel.routeType==1">フリガナ</td>
                                            <td class="td-value F3-M-18">{{viewModel.passengerNameKana}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">所在地</td>
                                            <td class="td-value F3-M-18">{{viewModel.address}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">緯度</td>
                                            <td class="td-value F3-M-18">{{viewModel.stationLat}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">経度</td>
                                            <td class="td-value F3-M-18">{{viewModel.stationLng}}</td>
                                        </tr>
                                        <tr>
                                            <td style="height:200px" class="td-key F3-R-15 bgc8">コメント</td>
                                            <td class="td-value F3-M-18">{{viewModel.stationNote}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-bordered window-table">
                                    <tbody>
                                        <tr v-show="viewModel.startPassengers&&viewModel.startPassengers.length>0">
                                            <td class="td-key F3-R-15 bgc8">乗車メンバ—</td>
                                            <td class="td-value F3-M-18">
                                                <label :key="sp" v-for="(item,sp) in viewModel.startPassengers">{{item.name}}<span v-if="sp!=viewModel.startPassengers.length-1">、</span></label>
                                            </td>
                                        </tr>
                                        <tr v-show="viewModel.arrivePassengers&&viewModel.arrivePassengers.length>0">
                                            <td class="td-key F3-R-15 bgc8">降車メンバ—</td>
                                            <td class="td-value F3-M-18">
                                                <label :key="ap" v-for="(item,ap) in viewModel.arrivePassengers">{{item.name}}<span v-if="ap!=viewModel.arrivePassengers.length-1">、</span></label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-5 column">
                                <div class="mapCss" v-show="viewModel.routeType==0">
                                    <GoogleMap ref="tMap"
                                        :center-point="centerPoint"
                                        :map-id="mapId2">
                                    </GoogleMap>
                                </div>
                                <div class="mapCss" >
                                    <GoogleMap ref="gMap" v-show="viewModel.routeType==1"
                                        :center-point="centerPoint"
                                        :map-id="mapId">
                                    </GoogleMap>
                                </div>
                            </div>
                        </div>
                        <div v-show="viewModel.routeType==1">
                            <div class="row clearfix boottom">
                                <div class="col-md-4 column" style="width: 100%">
                                    <button class="window-button" data-dismiss="modal" @click="commitServer">乗客詳細</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
label {
  font-weight:300;
}
.modal-dialog{
    width: 80%;
    margin-top: 4%;
}
.modal-header{
    border-bottom: 0px;
}
.modal-body{
    padding-left: 40px;
    padding-right: 40px;
}
.window-table{
    font-size: 16px;
    border: 2px solid rgb(148, 148, 148);
}
.table-bordered>tbody>tr>td{
    border: 1px solid rgb(148, 148, 148);
}
.td-title{
    background-color: #797979;
    color: #fff;
    font-size: 22px
}
.td-key{
    width: 30%;
    background-color: #DDDDDD;
}
.table>tbody>tr>td{
    height: 50px;
    vertical-align: middle;
}
.table>tbody>tr>.td-value{
    padding-left: 30px;
}
.td-value{
    text-align: left;
    border: 1px solid #959595;
}
.boottom{
    margin-top: 2%;
    width: 100%
}
.window-button{
    width: 30%;
    height: 50px;
    border-radius: 10px;
    font-size: 2em;
    color: #fff;
    background-color: #717171;
}
.close{
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/MovementDetailedConfirm.vue